import { useBackgroundContext } from '../../contexts/BackgroundContext';
import { Plasma } from './Plasma';

type AnimatedBackgroundProps = {
  color?: string;
  opacity?: number;
  speed?: number;
  scale?: number;
};

/**
 * Full-bleed plasma layer mounted behind a page's content. It must live inside a
 * `position: relative` container; it paints over that container's own background
 * (via a negative z-index) but below the in-flow content. Pausing the animation
 * freezes the last frame without tearing down the WebGL context.
 */
export function AnimatedBackground({
  // Matches the site accent (--color-accent) so the plasma reads as brand orange.
  color = '#e8491c',
  opacity = 0.7,
  speed = 1,
  scale = 1.4,
}: AnimatedBackgroundProps) {
  const { isAnimated } = useBackgroundContext();

  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
      <Plasma
        color={color}
        opacity={opacity}
        speed={speed}
        scale={scale}
        mouseInteractive={false}
        paused={!isAnimated}
      />
    </div>
  );
}

export default AnimatedBackground;
